import React from 'react';
import PropTypes from 'prop-types';
import { Cell } from 'react-foundation';
import useIntl from '../../../../../hooks/useIntl';
import Loading from '../../../../common/Loading';
import styles from '../../PersonalInfoForm/PersonalInfoForm.module.scss';
import messages from '../messages';
import { stepOneFormStructure } from '../formStructure';
import FormStep from './FormStep';

const AnahitaFormStepOne = ({
  isLoading,
  values,
  handleChange,
  setFieldValue,
  handleCheckboxChange,
  handleBlur,
}) => {
  const { formatMessage } = useIntl();

  return isLoading ? (
    <Loading />
  ) : (
    <>
      <Cell small={12}>
        <p className={styles.formSubtitle}>
          {formatMessage(messages.formStepOneSubtitle)}
        </p>
      </Cell>
      <Cell small={12}>
        <b>{formatMessage(messages.sectionOneTitle)}</b>
        <br />
        <p>How do you rate your overall health? (select one)</p>
        <p>
          <b>1</b> - being the "Worst" and <b>10</b> - being the "Best"
        </p>
      </Cell>
      {stepOneFormStructure.map((item, i) => (
        <FormStep
          key={i}
          stepName="AnahitaStepOne"
          item={item}
          values={values}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
          handleCheckboxChange={handleCheckboxChange}
          handleBlur={handleBlur}
        />
      ))}
    </>
  );
};

AnahitaFormStepOne.propTypes = {
  isLoading: PropTypes.bool,
  values: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  setFieldValue: PropTypes.func,
};

export default AnahitaFormStepOne;
